<div #container class="monaco-diff"></div>
